/**
 * Optional alias shown to the left of the source entity name in virtual FK rows.
 * Black, italic (readable in dark mode with light text).
 */
export default function FkRelationshipAlias({ alias }) {
  const t = typeof alias === 'string' ? alias.trim() : '';
  if (!t) return null;
  return (
    <span
      className="text-black dark:text-gray-100 italic font-normal flex-shrink-0 mr-1"
      title={t}
    >
      {t}
    </span>
  );
}
